import React, { useState, useEffect, useRef, Fragment } from 'react';
import Header from '../commons/Header';
import Footer from '../commons/Footer';
import { useHistory, NavLink, Link } from "react-router-dom";
import { PROJECTNAMEALIAS, NFTAPIBASENAME, COLLECTIONIMAGEBASEURL, USERCOLLECTIONIMAGEBASEURL, NFTIMAGEBASEURL } from '../helpers/Setup'
import { showToast, callAPI, showHttpError, checkIfUserIsLoggedIn, getAllSessionData, handleCartManipulation, getBlockChainContract } from '../helpers/Library';
import Loader from '../commons/Loader';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import moment from 'moment';
import axios from 'axios';
import web3 from "web3";

const UserProfile = (props) => {
    const [showLoader, setShowLoader] = useState(false);
    const [showStatusCategory, setStatusCategory] = useState(false);
    const [userDetails, setUserDetails] = useState({});
    const [userCoverPic, setUserCoverPic] = useState('');
    const [userProfileImg, setProfileImg] = useState('');
    const [nftUserName, setUserName] = useState('');
    const [nftUserEmail, setUserEmail] = useState('');
    const [userFbLink, setUserFbLink] = useState('');
    const [userInstaLink, setUserInstaLink] = useState('');
    const [nftUserTwitterLink, setTwitterLink] = useState('');
    const [nftUserDiscordLink, setUserDiscordLink] = useState('');
    const [userWebsiteLink, setUserWebsiteLink] = useState('');
    const [nftUserBio, setUserBio] = useState('');
    const [userCreatedOn, setUserCreatedOn] = useState('');
    const [ownerAddr, setOwnerAddr] = useState('');

    const [showUserEditModal, setShowUserEditModal] = useState(false);

    const [editProfileImg, setEditProfileImg] = useState('');
    const [editCoverImg, setEditCoverImg] = useState('');
    const [editUsername, setEditUsername] = useState('');
    const [editEmail, setEditEmail] = useState('');
    const [editBio, setEditBio] = useState('');
    const [editTwitterLink, setEditTwitterLink] = useState('');
    const [editInstaLink, setInstaLink] = useState('');
    const [editFacebookLink, setEditFacebookLink] = useState('');
    const [editDiscordLink, setEditDiscordLink] = useState('');
    const [editTelegramLink, setEditTelegramLink] = useState('');
    const [profileImg, setProfileImage] = useState('');
    const [coverImg, setCoverImage] = useState('');
    const [editWebsiteLink, setEditWebsiteLink] = useState('');
    const [isExternal, setIsExternal] = useState('')

    const [btnSaveCollection, setBtnSaveCollection] = useState(false)
    const [nfts, setNfts] = useState([])
    const [nftProfileStatus, setnftProfileStatus] = useState(0)
    const [searchString, setSearchString] = useState('')
    const [nftFilterType, setNftFilterType] = useState('status')
    const [nftStatus, setNftStatus] = useState('0');
    const [toValue, setToValue] = useState('0');
    const [fromValue, setFromValue] = useState('0');
    const [activeCatItems, setActiveCatItems] = useState('All');
    const [ownedNfts, setOwnedNfts] = useState([]);
    const [createdNfts, setCreatedNfts] = useState([]);
    const [onSaleNfts, setOnSaleNfts] = useState([]);
    const [nftTabSelected, setNftTabSelected] = useState('owned');

    /* Method defination for filtering profile status */
    let filterProfilerProfileStatus = (profileStatus) => {
        setnftProfileStatus(profileStatus, searchAllNftsByUser())
        /* setShowLoader(true)
        setTimeout(() => {
            alert('coming : '+ profileStatus + ' rendering : ' + nftProfileStatus)
            searchAllNftsByUser();
        }, 2000); */
    }

    /* Method defination for setting filter */
    let addFilterType = (param) => {
        console.log(nftFilterType.indexOf(param))
        if (nftFilterType.indexOf(param) == -1) {
            let filter = nftFilterType + ',' + param;
            setNftFilterType(filter);
        }
    }
    /* Method defination for handling price filter */
    let handlePriceFilter = () => {
        let min = document.getElementById('priceFilterMin').value;
        let max = document.getElementById('priceFilterMax').value;

        if (min != '' && max != '') {
            setFromValue(parseFloat(min))
            setToValue(parseFloat(max))
            addFilterType('price')
            setTimeout(() => {
                searchAllNftsByUser();
            }, 2000);
        } else {
            showToast('error', 'Please provide valid Min & Max Value');
        }
    }
    /* method defination for category filter */
    const handleCategoryItemClick = (itemName) => {
        setActiveCatItems(itemName === activeCatItems ? null : itemName);
        if (itemName === 'All') {
            setNftStatus('0')

        } else if (itemName === 'Listed') {
            setNftStatus('1')


        } else if (itemName === 'New') {
            setNftStatus('2')


        } else if (itemName === 'Has offer') {
            setNftStatus('3')

        } else if (itemName === 'On auction') {
            setNftStatus('2')
        }
        addFilterType('status')
        // console.log(nftStatus)
        searchAllNftsByUser();
    }


    /* Method defination for search all nfts by user */
    let searchAllNftsByUser = () => {
        let payload = { "orderingType": "0", "toUserUuid": props.match.params.id, "pageNo": "1", "pageSize": "20", "searchString": searchString, "status": nftStatus, "filterType": nftFilterType, "currencyId": "3", "fromValue": fromValue, "toValue": toValue, "profileStatus": nftProfileStatus }
        setShowLoader(true);
        callAPI('post', NFTAPIBASENAME + '/nft/market/public/searchAllNftsByUser', payload, false).then((res) => {
            setShowLoader(false);
            let response = res.data;
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg);
            } else {
                if (response.nfts != null) {
                    setNfts(response.nfts);
                }
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }


    const userProfileDetails = async (id) => {
        let contract = await getBlockChainContract();

        if (!contract) return;
        try {
            setShowLoader(true)
            const query = ` {
                        nfts(where: { or: [{ owner: "${getAllSessionData().account}" }, { creator: "${getAllSessionData().account}" }] }) {
                          id
                          tokenURI
                          price
                          owner
                          creator
                        }
                      }
                    `;
            // Fetch NFTs owned by the user from the subgraph
            const response = await fetch('https://api.studio.thegraph.com/query/108358/paybito_nft_marketplace/v0.0.1', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ query, variables: { owner: getAllSessionData().account } }),
            });
            console.log('Graphql response..', response);
            const { data } = await response.json();
           // console.log('My NFTs (raw data):', data.nfts); // Debug log
            const now = Math.floor(Date.now() / 1000);
            // Process each NFT to fetch additional metadata
            const fetchNFTs = async (nftList) => {
                return Promise.all(
                    nftList.map(async (nft) => {
                        try {
                            // Replace 'ipfs://' with 'https://ipfs.io/ipfs/' for metadata URLs
                            const metadataUrl = nft.tokenURI.replace('ipfs://', 'https://ipfs.io/ipfs/');
                            console.log('Fetching metadata from:', metadataUrl); // Log metadata URL
                            const { data: metadata } = await axios.get(metadataUrl);
                            const offer = await contract.methods.getOffer(nft.id).call();
                            const isOfferExpired = offer[2] > 0 && now > offer[2]; // Check expiration
                            const expirationTime = await contract.methods.getListingExpiration(nft.id).call();
                            const isExpired = expirationTime > 0 && now > expirationTime;
                            // Map the NFT data with metadata and price
                            console.log('My NFTOffer:', {
                                offerer: offer[0],
                                offerAmount: offer[1],
                                offerExpiration: offer[2],
                                isExpired: isOfferExpired,
                            });

                            return {
                                ...nft,
                                metadata,
                                offer: {
                                    offerer: offer[0],
                                    offerAmount: offer[1],
                                    offerExpiration: offer[2],
                                    isExpired: isOfferExpired,
                                },
                                expirationTime,
                                isExpired,
                            };

                        } catch (error) {
                            showToast('error','Error fetching metadata:'+ error);
                            return { ...nft, metadata: null };
                        }
                    })
                );
            };

            const processedNFTs = await fetchNFTs(data.nfts);
            // Categorize NFTs into owned, created, and on sale
            const owned = processedNFTs.filter((nft) => nft.owner.toLowerCase() === getAllSessionData().account.toString().toLowerCase());
            const created = processedNFTs.filter((nft) => nft.creator.toLowerCase() === getAllSessionData().account.toString().toLowerCase());
            const onSale = processedNFTs.filter(
                (nft) =>
                    nft.price !== null &&
                    nft.price > 0 &&
                    (nft.owner.toLowerCase() === getAllSessionData().account.toString().toLowerCase())
            );
            
            console.log('Owned NFTs:', owned);
            console.log('Created NFTs:', created);
            console.log('On Sale NFTs:', onSale);
            setShowLoader(false)
            setOwnedNfts(owned);
            setCreatedNfts(created);
            setOnSaleNfts(onSale);
            setNfts(created)
            setShowLoader(false)
        } catch (error) {
            setShowLoader(false)
            showToast('error','Error loading NFTs'+ error);
            showToast('error',  error)
        }

        /* let payload = { "toUserUuid": id }
        callAPI('post', NFTAPIBASENAME + '/nft/market/public/getMarketplaceUser', payload, true).then((res) => {
            let response = res.data;
            if(response.error.error_data!= '0'){
                showToast('error', response.error.error_msg)
                setTimeout(() => {
                    setShowLoader(false)
                    props.history.push("/");
                }, 1000);
            }else{
                setShowLoader(false)
                let uDetails = response.nftUser;
                let userAddr = uDetails.userAddresses[0]
                // console.log(userAddr.userPubKey)
                if (userAddr != undefined) {
                    setOwnerAddr(userAddr.userPubKey);
                } else {
                    setOwnerAddr('')
                }
                setUserDetails(uDetails)
                console.log(response.nftUser);
                setUserCoverPic(uDetails.userBannerImage);
                setProfileImg(uDetails.userProfileImage);
                setUserName(uDetails.userName);
                setUserBio(uDetails.userBio);
                setUserEmail(uDetails.userEmail);
                setUserWebsiteLink(uDetails.userWebsiteLink);
                setUserFbLink(uDetails.userFacebookLink);
                setUserInstaLink(uDetails.userInstagramLink);
                setUserDiscordLink(uDetails.userDiscordLink);
                setTwitterLink(uDetails.userTwitterLink);
    
                setUserCreatedOn(uDetails.createdOn);
                searchAllNftsByUser();
             }
        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })*/
    }

    let openEditProfileModal = (data) => {

        setEditProfileImg(data.userProfileImage);
        setEditCoverImg(data.userBannerImage);
        setEditEmail(data.userEmail)
        setEditUsername(data.userName);
        setEditBio(data.userBio);
        setEditTwitterLink(data.userTwitterLink);
        setInstaLink(data.userInstagramLink);
        setEditDiscordLink(data.userDiscordLink);
        setEditFacebookLink(data.userFacebookLink);
        setEditWebsiteLink(data.userWebsiteLink);
        setIsExternal(data.isExternal);
        // console.log('edit profile data', data)
        //console.log('isExternal',isExternal)
        setShowUserEditModal(true)
    }

    const updateUserProfile = () => {
        console.log('Profile Image value', profileImg)
        if (profileImg != null && coverImg != null && editUsername != null && editBio != null && editEmail != null) {
            let formData = new FormData();

            if (profileImg) {
                formData.append('profile_file', profileImg)
            } else {
                formData.append('profile_image', editProfileImg)
            }
            if (coverImg) {
                formData.append('banner_file', coverImg)
            } else {
                formData.append('banner_image', editCoverImg);
            }


            formData.append('user_uuid', getAllSessionData().uuid);
            formData.append('user_name', editUsername);
            formData.append('user_email', editEmail);
            formData.append('user_facebook', editFacebookLink);
            formData.append('user_twitter', editTwitterLink);
            formData.append('user_instagram', editInstaLink);
            formData.append('user_discord', editDiscordLink);
            formData.append('user_bio', editBio);
            formData.append('user_website', editWebsiteLink);
            formData.append('is_external', isExternal);
            formData.append('banner_file', coverImg);
            setShowLoader(true);
            axios.post(NFTAPIBASENAME + '/nft/market/updateMarketplaceUser', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": "bearer " + getAllSessionData().token,
                },
            })
                .then((res) => {
                    let response = res.data;
                    setShowLoader(false);
                    if (response.error.error_data != 0) {
                        showToast('error', response.error.error_msg)
                    } else {
                        setShowUserEditModal(false)
                        showToast('success', 'User profile updated successfully')
                        setTimeout(() => {
                            window.location.reload()
                        }, 2000)
                    }
                })
                .catch((error) => {
                    setShowLoader(false);
                    showHttpError(error)
                });

        } else {
            showToast('error', 'Please provide all the field')
        }

    }



    useEffect(() => {
        // if (!checkIfUserIsLoggedIn()) {
        //     showToast('error', 'Please login to continue',);
        //     setTimeout(() => {
        //         props.history.push("/");
        //     }, 1000);
        // } else {
        //     userProfileDetails(props.match.params.id);
        // }
        userProfileDetails(props.match.params.id);
    }, [])

    return (
        <Fragment>
            <Header />
            <div >
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12 pl-0 pr-0">
                            <div className="coverPictureSection">
                                {
                                    userCoverPic ?
                                        (
                                            <img src={USERCOLLECTIONIMAGEBASEURL + '/' + userCoverPic} className="cover-picture" />

                                        ) :
                                        (
                                            <img src="https://img.freepik.com/free-vector/v915-red-blue_53876-174923.jpg" alt='userProfile' className="cover-picture" />

                                        )
                                }
                            </div>
                        </div>
                    </div>
                    <div className="profile-name-section">
                        <div className="row mb-2">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-6 pl-3">
                                        {
                                            userProfileImg ?
                                                (
                                                    <img src={USERCOLLECTIONIMAGEBASEURL + '/' + userProfileImg} className="img-fluid rounded-circle" alt="Image" style={{ width: '224px', height: '224px' }} />
                                                ) :
                                                (
                                                    <img src="https://cdn-icons-png.flaticon.com/512/149/149071.png" className="img-fluid rounded-circle" alt="Image" style={{ width: '224px', height: '224px' }} />
                                                )
                                        }
                                    </div>
                                    <div className="col-md-6">
                                        <h1 className="specification-user"></h1>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>
            <div className="container">
                {/* <div className="row">
                    <div className="col-md-6 col-sm-6">
                        <h2 className='mt-3 text-capitalize mb-0' style={{ fontSize: '2em', fontWeight: 500 }}>{nftUserName ? nftUserName : 'Unnamed'}</h2>
                        <p className='mt-0 text-dark'>{ownerAddr}</p>

                    </div>
                    <div className="col-md-6 col-sm-6 text-right">
                        <div className="row">
                            <div className="col-md-10">
                                <b>Joined In</b>
                                <p><i>{userCreatedOn}</i></p>
                            </div>
                            <div className="col-md-2">
                                {getAllSessionData().uuid == props.match.params.id && <i className="fa fa-edit " title='Edit Profile' style={{ cursor: "pointer" }} onClick={() => { openEditProfileModal(userDetails); }}></i>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 col-sm-12 mt-4 mb-3 text-center">
                        <table className="table table-borderless table-hover">
                            <tr>
                                <td className='col-md-4'>
                                    <FaBook size={22} color='#007bff' />
                                    <b className='icons-position'>Bio:</b>
                                </td>
                                <td className='col-md-8 text-left'>{nftUserBio ? nftUserBio : 'No Data'}</td>
                            </tr>
                            <tr>

                                <td className='col-md-4'>
                                    <MdOutlineMarkEmailUnread size={22} color='#007bff' />
                                    <b className='icons-position'>Email:</b>
                                </td>
                                <td className='col-md-8 text-left'>{nftUserEmail ? nftUserEmail : 'No Data'}</td>
                            </tr>

                            <tr>
                                <td className='col-md-4'>
                                    <FaGlobe size={22} color='#007bff' />
                                    <b className='icons-position'>Website Link:</b>
                                </td>
                                <td className='col-md-8 text-left'>{userWebsiteLink ? userWebsiteLink : 'No Data'}</td>
                            </tr>

                            <tr>
                                <td className='col-md-4'>
                                    <FaFacebookSquare size={22} color='#007bff' />
                                    <b className='icons-position'>Facebook Link:</b></td>
                                <td className='col-md-8 text-left'>{userFbLink ? userFbLink : 'No Data'}</td>
                            </tr>

                            <tr>
                                <td className='col-md-4'>
                                    <FaInstagram size={22} color='#007bff' />
                                    <b className='icons-position'>Instagram Link:</b>
                                </td>
                                <td className='col-md-8 text-left'>{userInstaLink ? userInstaLink : 'No Data'}</td>
                            </tr>

                            <tr>
                                <td className='col-md-4'>
                                    <FaTwitter size={22} color='#007bff' />
                                    <b className='icons-position'>Twitter Link:</b></td>
                                <td className='col-md-8 text-left'>{nftUserTwitterLink ? nftUserTwitterLink : 'No Data'}</td>
                            </tr>

                            <tr>
                                <td className='col-md-4'>
                                    <FaDiscord size={22} color='#007bff' />
                                    <b className='icons-position'>Discord Link:</b></td>
                                <td className='col-md-8 text-left'>{nftUserDiscordLink ? nftUserDiscordLink : 'No Data'}</td>
                            </tr>


                        </table>
                    </div>
                </div> */}
                <div className="row">
                    <div className="col-md-2">
                        <span className={`${nftTabSelected == 'owned' ? 'profile-status-active' : 'profile-status-inactive'}`} onClick={() => { setNftTabSelected('owned') }}>Owned</span>
                    </div>
                    <div className="col-md-2">
                        <span className={`${nftTabSelected == 'onsale' ? 'profile-status-active' : 'profile-status-inactive'}`} onClick={() => { setNftTabSelected('onsale') }}>On Sale</span>
                    </div>
                    <div className="col-md-2">
                        <span className={`${nftTabSelected == 'created' ? 'profile-status-active' : 'profile-status-inactive'}`} onClick={() => { setNftTabSelected('created') }}>Created</span>
                    </div>
                </div>
                <div className="row">

                    <div className="col-md-9 col-lg-9 col-sm-12 col-xs-12">
                        <div className="product-categorie-box">
                            <div className="tab-content">
                                <div role="tabpanel" className="tab-pane fade show active" id="grid-view">
                                    <div className="row">
                                    {nftTabSelected == 'owned' && <Fragment>
                                                {ownedNfts.map((nft) => (
                                                    <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4" key={nft.id}>
                                                        <Link to={`/asset/` + nft.metadata.collection + `/` + nft.id} data-toggle="tooltip" data-placement="right" title="View">
                                                            <div className="products-single fix">
                                                                <div className="box-img-hover">
                                                                    <img src={nft.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} className="img-fluid" alt="Image" style={{ width: '100%', height: '100%' }} />
                                                                </div>
                                                                <div className="why-text">
                                                                    <h4>{nft.metadata.name}</h4>
                                                                    <p>Price : {nft.price > 0 && nft.price != null ? web3.utils.fromWei(nft.price.toString(), 'ether') : 0} ETH</p>

                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                ))}
                                                {
                                                    ownedNfts.length == 0 && (

                                                        <div className="col-md-12 bg-secondary p-5">
                                                            <h1 className='text-white text-center'>No Nft found</h1>
                                                            <div className='text-center mt-3'>
                                                                {/* <a href="./create-nft" className='d-inline-block btn btn-primary'>Create Nft</a> */}

                                                            </div>
                                                        </div>

                                                    )

                                                }


                                            </Fragment>}
                                            {nftTabSelected == 'onsale' && <Fragment>
                                                {onSaleNfts.map((nft) => (
                                                    <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4" key={nft.id}>
                                                        <Link to={`/asset/` + nft.metadata.collection + `/` + nft.id} data-toggle="tooltip" data-placement="right" title="View">
                                                            <div className="products-single fix">
                                                                <div className="box-img-hover">
                                                                    <img src={nft.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} className="img-fluid" alt="Image" style={{ width: '100%', height: '100%' }} />
                                                                </div>
                                                                <div className="why-text">
                                                                    <h4>{nft.metadata.name}</h4>
                                                                    <p>Price : {nft.price > 0 ? web3.utils.fromWei(nft.price.toString(), 'ether') : parseFloat(nft.price)} ETH</p>

                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                ))}
                                                {
                                                    onSaleNfts.length == 0 && (

                                                        <div className="col-md-12 bg-secondary p-5">
                                                            <h1 className='text-white text-center'>No Nft found</h1>
                                                            <div className='text-center mt-3'>
                                                                {/* <a href="./create-nft" className='d-inline-block btn btn-primary'>Create Nft</a> */}

                                                            </div>
                                                        </div>

                                                    )

                                                }


                                            </Fragment>}
                                            {nftTabSelected == 'created' && <Fragment>
                                                {createdNfts.map((nft) => (
                                                    <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4" key={nft.id}>
                                                        <Link to={`/asset/` + nft.metadata.collection + `/` + nft.id} data-toggle="tooltip" data-placement="right" title="View">
                                                            <div className="products-single fix">
                                                                <div className="box-img-hover">
                                                                    <img src={nft.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} className="img-fluid" alt="Image" style={{ width: '100%', height: '100%' }} />
                                                                </div>
                                                                <div className="why-text">
                                                                    <h4>{nft.metadata.name}</h4>
                                                                    <p>Price : {nft.price > 0 ? web3.utils.fromWei(nft.price.toString(), 'ether') : parseFloat(nft.price)} ETH</p>

                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                ))}
                                                {
                                                    createdNfts.length == 0 && (

                                                        <div className="col-md-12 bg-secondary p-5">
                                                            <h1 className='text-white text-center'>No Nft found</h1>
                                                            <div className='text-center mt-3'>
                                                                {/* <a href="./create-nft" className='d-inline-block btn btn-primary'>Create Nft</a> */}

                                                            </div>
                                                        </div>

                                                    )

                                                }


                                            </Fragment>}


                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-sm-12 col-xs-12 sidebar-shop-left">
                        <div className="product-categori">
                            <div className="search-product">
                                <div>
                                    <input className="form-control" placeholder="Search here..." type="text" onChange={(e) => { setSearchString(e.target.value) }} />
                                    <button onClick={() => { searchAllNftsByUser() }}> <i className="fa fa-search" ></i> </button>
                                </div>
                            </div>
                            <div className="filter-sidebar-left">
                                <div className="title-left">
                                    <h3>Categories</h3>
                                </div>
                                <div className="list-group list-group-collapse list-group-sm list-group-tree" id="list-group-men" data-children=".sub-men">
                                    <div className="list-group-collapse sub-men">
                                        <a onClick={() => { setStatusCategory(!showStatusCategory) }} className="list-group-item list-group-item-action" href="javascript:void(0)" >Status <small className="text-muted">(100)</small><i className={`ml-2 fa + ${showStatusCategory ? 'fa-caret-up' : 'fa-caret-down'}`} aria-hidden="true"></i>
                                        </a>
                                        {showStatusCategory && <div className="collapse show" data-parent="#list-group-men">
                                            <div className="list-group">
                                                <a className={`list-group-item list-group-item-action ${activeCatItems === 'All' ? 'active' : ''}`} onClick={() => { handleCategoryItemClick('All') }}>All</a>
                                                <a className={`list-group-item list-group-item-action ${activeCatItems === 'Listed' ? 'active' : ''}`} onClick={() => { handleCategoryItemClick('Listed') }}>Listed</a>
                                                <a className={`list-group-item list-group-item-action ${activeCatItems === 'New' ? 'active' : ''}`} onClick={() => { handleCategoryItemClick('New') }}>New </a>
                                                {/* <a className={`list-group-item list-group-item-action ${activeCatItems === 'On auction' ? 'active' : ''}`} onClick={() => { handleCategoryItemClick('On auction') }}>On auction <small className="text-muted">(10)</small></a> */}
                                                <a className={`list-group-item list-group-item-action ${activeCatItems === 'Has offer' ? 'active' : ''}`} onClick={() => { handleCategoryItemClick('Has offer') }}>Has offer </a>

                                            </div>
                                            {/* <div className="list-group mt-2">
                                                    <select name="" id="" className='form-control' value={statusFilter} onChange={onFilterStatusChange}>
                                                        <option value="">--Select Status</option>
                                                        <option value="0">All</option>
                                                        <option value="1">Listed</option>
                                                        <option value="3">New</option>
                                                        <option value="2">On auction</option>
                                                        <option value="4">Has offer</option>
                                                    </select>
                                                </div> */}
                                        </div>}
                                    </div>



                                </div>
                            </div>
                            <div className="filter-price-left">
                                <div className="title-left">
                                    <h3>Price</h3>
                                </div>
                                <div className="price-box-slider">
                                    {/* <select className="form-control">
                                            <option value="">Select Currency</option> */}
                                    {/* <option value="1">BTC</option> */}
                                    {/* <option value="2">ETH</option> */}
                                    {/* <option value="3">DOGE</option> */}
                                    {/* </select> */}
                                    <div className="row mt-2 ml-2 mr-2">
                                        <input type="text" className="form-control col-md-4" placeholder="Min" id="priceFilterMin" />
                                        <span className="col-md-4">-</span>
                                        <input type="text" className="form-control col-md-4" placeholder="Max" id="priceFilterMax" />
                                    </div>
                                    <p>

                                        <button className="btn hvr-hover" type="submit" style={{ width: '100%' }} onClick={() => {
                                            handlePriceFilter()
                                        }}>Filter</button>
                                    </p>
                                </div>
                            </div>
                            {/* <div className="filter-price-left">
                                    <div className="title-left">
                                        <h3>Rarity</h3>
                                    </div>
                                    <div className="price-box-slider">
                                        <div className="row mt-2 ml-2 mr-2">
                                            <input type="text" className="form-control col-md-4" placeholder="1" />
                                            <span className="col-md-4">-</span>
                                            <input type="text" className="form-control col-md-4" placeholder="6,571" />
                                        </div>
                                        <p>

                                            <button className="btn hvr-hover" type="submit" style={{ width: '100%' }}>Filter</button>
                                        </p>
                                    </div>
                                </div> */}
                        </div>
                    </div>
                </div>
            </div>

            <Fragment>
                <div className={"modal  " + (showUserEditModal ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: showUserEditModal ? 'block' : 'none', paddingRight: '17px', background: '#0000008c', overflow: 'scroll' }}>
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">Edit Profile</h3>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setShowUserEditModal(false) }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div className="form-group">
                                            <label>Edit Profile Image *</label>
                                            <small> (File size should not be exceeded more than 25MB.)</small>
                                            <input type="file" className="form-control" onChange={(e) => {
                                                let selectedFile = e.target.files[0]
                                                if (selectedFile.type === 'image/jpeg' || selectedFile.type === 'image/jpg' || selectedFile.type === 'image/png') {
                                                    if (selectedFile.size <= 25 * 1024 * 1024) {
                                                        setBtnSaveCollection(false)
                                                        setProfileImage(e.target.files[0])
                                                    } else {
                                                        setBtnSaveCollection(true)
                                                        showToast("error", "File size should not be exceeded more than 25MB.")
                                                    }

                                                } else {
                                                    setBtnSaveCollection(true)
                                                    showToast('error', 'Please select valid file')
                                                }


                                            }} />
                                            <small>Upload only jpeg, jpg and png file type.</small>
                                            <p>{editProfileImg}</p>
                                        </div>
                                        <div className="form-group">
                                            <label>Edit Cover Image *</label>
                                            <small> (File size should not be exceeded more than 25MB.)</small>
                                            <input type="file" className="form-control" onChange={(e) => {
                                                let selectedFile = e.target.files[0]
                                                if (selectedFile.type === 'image/jpeg' || selectedFile.type === 'image/jpg' || selectedFile.type === 'image/png') {
                                                    if (selectedFile.size <= 25 * 1024 * 1024) {
                                                        setBtnSaveCollection(false)
                                                        setCoverImage(e.target.files[0])
                                                    } else {
                                                        setBtnSaveCollection(true)
                                                        showToast("error", "File size should not be exceeded more than 25MB.")
                                                    }

                                                } else {
                                                    setBtnSaveCollection(true)
                                                    showToast('error', 'Please select valid file')
                                                }

                                            }} />
                                            <small>Upload only jpeg, jpg and png file type.</small>
                                            <p>{editCoverImg}</p>
                                        </div>
                                        <div className="form-group">
                                            <label>Edit Username *</label>
                                            <input type="text" className="form-control" value={editUsername} onChange={(e) => {
                                                setEditUsername(e.target.value)
                                            }} />
                                        </div>
                                        <div className="form-group">
                                            <label>Edit Bio *</label>
                                            <input type="text" className="form-control" value={editBio} onChange={(e) => {
                                                setEditBio(e.target.value)
                                            }} />
                                        </div>
                                        <div className="form-group">
                                            <label>Edit Email *</label>

                                            <input type="text" className="form-control" value={editEmail} onChange={(e) => {
                                                setEditEmail(e.target.value)
                                            }} disabled={isExternal == 0 ? true : false} />
                                        </div>

                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div className="form-group">
                                            <label>Edit Website Link</label>
                                            <input type="text" className="form-control" value={editWebsiteLink} onChange={(e) => {
                                                setEditWebsiteLink(e.target.value)
                                            }} />
                                        </div>
                                        <div className="form-group">
                                            <label>Edit Twitter Link</label>
                                            <input type="text" className="form-control" value={editTwitterLink} onChange={(e) => {
                                                setEditTwitterLink(e.target.value)
                                            }} />
                                        </div>
                                        <div className="form-group">
                                            <label>Edit Facebook Link</label>
                                            <input type="text" className="form-control" value={editFacebookLink} onChange={(e) => {
                                                setEditFacebookLink(e.target.value)
                                            }} />
                                        </div>
                                        <div className="form-group">
                                            <label>Edit Instagram Link</label>
                                            <input type="text" className="form-control" value={editInstaLink} onChange={(e) => {
                                                setInstaLink(e.target.value)
                                            }} />
                                        </div>
                                        <div className="form-group">
                                            <label>Edit Discord Link</label>
                                            <input type="text" className="form-control" value={editDiscordLink} onChange={(e) => {
                                                setEditDiscordLink(e.target.value)
                                            }} />
                                        </div>
                                        {/* <div className="form-group">
                                            <label>Edit Telegram Link</label>
                                            <input type="text" className="form-control" value={editTelegramLink} onChange={(e) => {
                                                setEditTelegramLink(e.target.value)
                                            }} />
                                        </div> */}


                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <button className="btn btn-primary" onClick={() => { updateUserProfile() }} disabled={btnSaveCollection}>Save</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>


            <Footer />
            <Loader show={showLoader} />
        </Fragment>
    )
}

export default UserProfile;